import React, { useState } from 'react';
import Chatbot from 'react-chatbot-kit';
import 'react-chatbot-kit/build/main.css';
import './Chatbot.css';

import config from './config';
import MessageParser from './MessageParser';
import ActionProvider from './ActionProvider';

import { FaHeadset } from 'react-icons/fa';

const BazurtoChatbot = () => {
  const [showBot, toggleBot] = useState(false);


  return (
    <div className="chatbot-container">
      {showBot && (
        <Chatbot
          config={config}
          messageParser={MessageParser}
          actionProvider={ActionProvider}
          placeholderText={config.placeholderText}
        />
      )}
      <button className="chatbot-button" onClick={() => toggleBot((prev) => !prev)}>
        <FaHeadset className="chatbot-icon" />
      </button>
    </div>
  );
};

export default BazurtoChatbot;
